import React from 'react';
import { Scissors, ClipboardPaste } from 'lucide-react';

function EmptyState({ onPaste, t }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center" data-testid="empty-state">
      <div className={`relative w-64 h-40 mb-8 rounded-xl overflow-hidden ${t.cardBorder} border`}>
        <img 
          src="https://images.pexels.com/photos/50691/drill-milling-milling-machine-drilling-50691.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Máquina de corte" 
          className="w-full h-full object-cover opacity-40" 
        />
        <div className={`absolute inset-0 ${t.key === 'dark' ? 'bg-gradient-to-t from-zinc-950 via-zinc-950/60 to-transparent' : 'bg-gradient-to-t from-white via-white/60 to-transparent'}`} />
        <Scissors className="w-12 h-12 absolute bottom-4 left-1/2 -translate-x-1/2 text-sky-500" />
      </div>
      <h2 className={`text-xl font-semibold ${t.textSec} mb-2`} style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
        Sem dados importados
      </h2>
      <p className={`text-sm ${t.textMut} max-w-md mb-6`}>
        Cole os dados da tabela do software ou importe um ficheiro Excel para começar a analisar o desempenho.
      </p>
      <button
        onClick={onPaste}
        className="flex items-center gap-2 px-6 py-3 rounded-lg bg-sky-500 text-white hover:bg-sky-600 transition-colors"
      >
        <ClipboardPaste className="w-5 h-5" />
        <span className="font-medium">Colar Dados</span>
      </button>
    </div>
  );
}

export default EmptyState;
